import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

import { typeLabel, KEY_TYPES, formatDate } from '../../lib/clubOps';

@observer
class MyClubKeys extends Component {
    componentDidMount() {
        const { clubKeyStore } = this.props.stores;
        clubKeyStore.loadMine();
    }

    confirm = async (id) => {
        const { clubKeyStore } = this.props.stores;
        await clubKeyStore.confirmKey(id);
    }

    render() {
        const { clubKeyStore } = this.props.stores;
        const { myKeys = [] } = clubKeyStore;

        return (
            <div class='w-100 mb-4'>
                <h6 class='mb-2'>
                    <i class='fa-duotone fa-key me-2' />
                    <Text id='clubOps.my-keys-title'>My club keys</Text>
                </h6>

                {myKeys.length === 0 ? (
                    <div class='text-body-secondary py-2'>
                        <Text id='clubOps.my-keys-empty'>You have no club keys registered.</Text>
                    </div>
                ) : (
                    <ul class='list-group'>
                        {myKeys.map((key) => {
                            const confirmed = !!key.confirmation?.date;
                            return (
                                <li key={key.uuidv4} class='list-group-item d-flex flex-wrap justify-content-between align-items-center gap-2'>
                                    <div>
                                        <strong>{key.label}</strong>
                                        <small class='d-block text-body-secondary'>
                                            {typeLabel(KEY_TYPES, key.keyType)} {key.number} · <Text id='clubOps.my-keys-issued'>Issued</Text> {formatDate(key.issuedDate)}
                                        </small>
                                    </div>
                                    {confirmed ? (
                                        <span class='badge bg-success'>
                                            <Text id='clubOps.my-keys-confirmed'>Confirmed</Text>
                                        </span>
                                    ) : (
                                        <button type='button' class='btn btn-sm btn-primary rounded-pill btn-confirm' onClick={() => this.confirm(key.id)}>
                                            <Text id='clubOps.my-keys-confirm'>Confirm receipt</Text>
                                        </button>
                                    )}
                                </li>
                            );
                        })}
                    </ul>
                )}
            </div>
        );
    }
}

export default MyClubKeys;
